import { useEffect } from "react";
import { Frame, Head } from "../components/spec/Frame";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    overline: "Legal",
    sections: [
      ["Overview", "This Privacy Policy explains how REGERA handles information submitted through this website. This is a placeholder structure prepared for review by REGERA and its legal advisors, and should be replaced with the firm's finalised policy prior to production use."],
      ["Information we collect", "When you submit an enquiry, we collect the details you provide — such as your name, organisation, designation, email, phone, country, sector and message — solely to respond to your request."],
      ["How we use information", "Enquiry information is used to respond to your request and to manage our professional relationship. We do not sell personal information."],
      ["Data retention", "Enquiry records are retained only as long as necessary for the purposes described here or as required by applicable law."],
      ["Contact", "For any privacy questions, contact us at info@regera.biz."],
    ],
  },
  terms: {
    title: "Terms of Use",
    overline: "Legal",
    sections: [
      ["Overview", "These Terms of Use govern your use of the REGERA website. This is a placeholder structure prepared for review by REGERA and its legal advisors, and should be replaced with the firm's finalised terms prior to production use."],
      ["Use of content", "Content on this site is provided for general information about REGERA's services and is not professional advice. Engagements are governed by separate written agreements."],
      ["Confidential engagements", "Certain engagements referenced on this site are subject to confidentiality and are shown as NDA / Confidential Client. No confidential client information is disclosed."],
      ["Intellectual property", "The REGERA name, logo and content are the property of REGERA and may not be used without permission."],
      ["Contact", "For any questions regarding these terms, contact us at info@regera.biz."],
    ],
  },
};

// One frame on desktop: title above the sections laid out in columns (customer review p13, footer pages).
export default function LegalPage({ type }) {
  const c = CONTENT[type];
  useEffect(() => {
    document.title = `${c.title} — REGERA`;
  }, [c.title]);

  return (
    <div data-testid={`legal-${type}`}>
      <Frame id={`legal-${type}`} first>
        <Head as="h1" size="lg" fit overline={c.overline} title={c.title} />
        <div className="rg-gap mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-10">
          {c.sections.map(([h, body]) => (
            <div key={h} data-pg-item className="border-t border-white/10 pt-5">
              <h2 className="font-display text-2xl font-bold tracking-tight text-white mb-3 rg-fs-h3">{h}</h2>
              <p className="text-regera-dim leading-relaxed rg-fs-text">{body}</p>
            </div>
          ))}
        </div>
      </Frame>
    </div>
  );
}
